<template>
    <div class="page justopp no-container-layout" v-bind="$attrs">
      <justopp-header></justopp-header>
      <div
        class="relative mini-hero center flex flex-middle flex-center padding-2xl-vertical box-shadow-2 overflow-hidden"
        style="min-height: 120px;">
        <div
          v-rellax="{ speed: -2.5 }"
          :style="{ 'background-image': `url('${getDynamicAssetUrl(bgSrc)}')` }"
          class="bg absolute-cover bg-cover z-level-1"></div>
        <div class="shader-4 absolute-cover z-level-2"></div>
        <div class="container container-l margin-auto-horizontal z-level-3">
          <block v-rellax="{ speed: -1.5 }">
            <fancy-title
              theme="bg"
              class="flex-start margin-remove"
              align="center"
              :h1="true"
              :title="title"
              :title-params="titleParams"
              :content="subTitle"></fancy-title>
          </block>
        </div>
      </div>
      <main class="" style="min-height: 300px;" :class="mainWrapperClass">
        <slot></slot>
      </main>
      <register-cta-section></register-cta-section>
      <justopp-footer></justopp-footer>
      <site-credits></site-credits>
      <justopp-mobile-footer />
    </div>
</template>

<script>
import JustoppHeader from "@/client/applications/justopp/components/JustoppHeader";
import JustoppFooter from "@/client/applications/justopp/components/JustoppFooter";
import JustoppMobileFooter from "@/client/applications/justopp/components/JustoppMobileFooter";
import RegisterCtaSection from "@/client/applications/justopp/components/RegisterCtaSection";


export default {
  components: { JustoppHeader, JustoppFooter, RegisterCtaSection, JustoppMobileFooter },

  props: {
    title: {
      type: String,
      Boolean,
      default: false,
    },
    titleParams: {
      type: Object,
      default: {},
    },
    subTitle: {
      type: String,
      Boolean,
      default: false,
    },
    bgSrc: {
      type: String,
      default: "images/default-layout/bg1.jpg",
    },
    bgUrl: {
      type: [String, Boolean],
      default: false,
    },
    mainWrapperClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // showHeader: this.$store.getters['talron/showHeader'],
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.mini-hero {
}
</style>
